import { render, staticRenderFns } from "./BridalLive.vue?vue&type=template&id=62f91609"
import script from "./BridalLive.vue?vue&type=script&lang=js"
export * from "./BridalLive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports